module.exports = __webpack_public_path__ + "static/media/logo.e086cc3b.png";